/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, fork } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* plansWatcher(): Generator<any, void, unknown> {
  // Mutation / submit actions — keep takeLatest (not screen-cancellable)
  yield takeLatest(ActionConstants.PAUSE_REVOKE_SUBSCRIPTION, workerSaga);
  yield takeLatest(ActionConstants.PUT_UPDATE_MERCHANT_SUBSCRIPTION_ACTION, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_MAX_PAYMENT_LINK_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_MERCHANT_SETTINGS_FLAG, workerSaga);
  yield takeLatest(ActionConstants.SET_MERCHANT_SETTINGS_FLAG, workerSaga);
  yield takeLatest(ActionConstants.CREATE_SUBSCRIPTION_LINK, workerSaga);
  yield takeLatest(ActionConstants.CANCEL_SUBSCRIPTION_LINK, workerSaga);
  yield takeLatest(ActionConstants.DUPLICATE_SUBSCRIPTION_LINK, workerSaga);
  yield takeLatest(ActionConstants.NOTIFY_SUBSCRIPTION_LINK, workerSaga);
  yield takeLatest(ActionConstants.EXPORT_SUBSCRIPTION_LINKS, workerSaga);
  yield takeLatest(ActionConstants.UPLOAD_SUBSCRIPTION_BULK, workerSaga);

  // List / screen-owned read actions — use takeLatestUntilApiCancel so route
  // changes can abort in-flight requests via cancelApiRequestAction
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_SUBSCRIPTION_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_SUBSCRIPTION_LINKS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_SUBSCRIPTION_LINK_DETAIL);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_BULK_UPLOAD_HISTORY);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_SUBSCRIPTION_PRESENTATIONS
  );
}
